import React from 'react';
import EmptyCell from './EmptyCell';

export default cellText => {
    if (cellText === null) {
        return <EmptyCell />;
    }
    return <div className="cell numeric">{cellText}</div>;
};



// WEBPACK FOOTER //
// ./src/view/common/table/formatters/PercentageShortTextCell.jsx